import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Container, Row } from 'reactstrap';
import { Redirect } from 'react-router-dom';
import TransactionLists from './components/TransactionLists';

class Transactions extends PureComponent {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        itemID: PropTypes.string,
      }).isRequired,
    }).isRequired,
  }

  constructor() {
    super();
    this.userData = JSON.parse(localStorage.getItem('userData'));
  }

  render() {
    const { match } = this.props;
    const { params } = match;
    const { pagetype } = params;

    if (this.userData == null) {
      return (<Redirect to="/login" />);
    }

    return (
      <Container>
        <Row>
          <TransactionLists pagetype={pagetype} />
        </Row>
      </Container>
    );
  }
}

export default Transactions;
